const DocMenuConfig = [

  {
    heading: "Payout",
    route: "",
    pages: [

      {
        heading: "International",
        route: "/internationalPayout/internationalPayout",
        svgIcon: "media/icons/duotune/finance/fin001.svg",
        fontIcon: "bi-archive"
      }

    ]
  }

];

export default DocMenuConfig;


// {
//   heading: "Sender",
//       route: "",
//     pages: [
//   {
//     heading: "Sender",
//     route: "/senders/senders",
//     svgIcon: "media/icons/duotune/communication/com006.svg",
//     fontIcon: "bi-app-indicator"
//   }
//
// ]
// },
// {
//   heading: "Recipient",
//       route: "",
//     pages: [
//
//
//   {
//     heading: "Recipient",
//     route: "/recipients/recipients",
//     svgIcon: "media/icons/duotune/art/art002.svg",
//     fontIcon: "bi-app-indicator"
//   }
// ]
// },
// {
//   heading: "Sub-Client",
//       route: "",
//     pages: [
//
//
//   {
//     heading: "Sub-Client",
//     route: "/channels/channels",
//     svgIcon: "media/icons/duotune/art/art002.svg",
//     fontIcon: "bi-app-indicator"
//   }
// ]
// },
